function kerroin() {
    var pituus = parseFloat($("#pituus-value span").text().replace(" mm",""));
    var leveys = parseFloat($(".custom-leveys").attr("data-hyotyleveys"))/1000;
    var kerroin = parseFloat(1/leveys).toFixed(2);
    var myyntiera = parseFloat($(".custom-myyntiera").attr("data-myyntiera"));
  var paketissa = parseFloat(myyntiera*pituus)/1000;
    $(".custom-kerroin").data("kerroin",kerroin);
  $("#menekki").data("kerroin",kerroin);
    $(".custom-kerroin span").text(kerroin);
  $(".custom-paketissa span").text(paketissa.toFixed(2));
  $("#menekki").data("jm",paketissa.toFixed(2));

    
             //var ale2 = parseFloat($(".custom-paketissam2").data("hinta"))/100;
             var neliomm = parseFloat(leveys*pituus)/1000;
			 var neliom2 = parseFloat(parseFloat(neliomm/1000)/1000);
			    var metrit = parseFloat(myyntiera*pituus);
			    var totalPituus = parseFloat(metrit/1000);
			 var pakettim2 = parseFloat(myyntiera*neliomm); /* Neliöitä paketissa */

  setTimeout(function() {
              var hinta = $(".price__regular .price-item").text().replace("€","").replace("EUR","").replace(",","");
              var ale2 = parseFloat(hinta)/100;
              var kplhinta = parseFloat(ale2/myyntiera);
			  $(".nelio .kplhinta").text(kplhinta.toFixed(2));
    },1000);
			    

  
			    $(".custom-paketissam2 .totalPituus").text(totalPituus.toFixed(2));
                $(".custom-paketissam2 .totalPituus").append("jm");
              
			    $(".custom-paketissam2 .totalNeliot").text(pakettim2.toFixed(2));
			    $(".custom-paketissam2 .totalNeliot").append("m²")
			   



  
$("#menekki").each(function(e) {
         var 	t=$("input", this).val(),
         		i=$("#product-length"),
         		l=$("#product-length-visib"),
         		e=$("#product-spare"),
                 f=$("#product-spare-visib"),
         		jm=parseFloat($(this).data("jm")),
         		packs=$("#product-packs"),
         		n=$(this).data("kerroin");

        
        		 i.val(Math.round(t*n*100+Number.EPSILON)/100);
        		 l.text(Math.round(t*n*100+Number.EPSILON)/100 + " m");
        		 e.text(Math.round(1.1*i.val()) + " m");
          f.text(Math.round(1.1*i.val()) + " m");
                  
        		 packs.text(parseFloat(Math.round(1.1*i.val())/jm).toFixed(2) + " pkt");
                  
        
         });
  
  }
$(document ).ready(function() {

      var variantLength = $("variant-selects").length;
var jmSelected = parseFloat($("variant-selects input[type=radio]:checked+label").text().replace(" mm",""));
        console.log(variantLength)

kerroin();
      $("variant-selects label").on("click", function(e) {
       
        setTimeout(function() {
        var noniin = $("variant-selects input[type=radio]:checked").val();
        console.log(noniin);
          var hinta = $(".price__regular .price-item").text().replace("€","").replace("EUR","").replace(",","");
  console.log("Uusi"+hinta);
          kerroin();
          },1500);
      });

  
  

$("#menekki").on("input",function(e) {
         var 	t=e.target.value,
         		i=$("#product-length"),
         		l=$("#product-length-visib"),
         		e=$("#product-spare"),
                 f=$("#product-spare-visib"),
         		jm=parseFloat($(this).data("jm")),
         		packs=$("#product-packs"),
         		n=$(this).data("kerroin");

        
        		 i.val(Math.round(t*n*100+Number.EPSILON)/100);
        		 l.text(Math.round(t*n*100+Number.EPSILON)/100 + " m");
        		 e.text(Math.round(1.1*i.val()) + " m");
          f.text(Math.round(1.1*i.val()) + " m");
                  
        		 packs.text(parseFloat(Math.round(1.1*i.val())/jm).toFixed(2) + " pkt");
                  
        
         });

  
  });


  document.addEventListener('DOMContentLoaded', function () {
    const minusBtn = document.querySelector('.quantity-minus');
    const plusBtn = document.querySelector('.quantity-plus');
    const input = document.querySelector('.quantity-input');

    if (!input || !minusBtn || !plusBtn) return;

    minusBtn.addEventListener('click', () => {
      let current = parseInt(input.value);
      let min = parseInt(input.getAttribute('min')) || 1;
      if (current > min) {
        input.value = current - 1;
      }
    });

    plusBtn.addEventListener('click', () => {
      let current = parseInt(input.value);
      let max = parseInt(input.getAttribute('max')) || 999;
      if (current < max) {
        input.value = current + 1;
      }
    });
  });
